import axios from "axios";
import { apiUrl, PORT } from "../../environment";
// import { getInfo } from "./Auth.header";
// import queryString from "query-string";

const login = async (data, dispatch) => {
    const url = `${apiUrl}${PORT}/auth-service/login`;
    try {
        const response = await axios.post(url, data);
        if (response.data.status) {
            localStorage.setItem("user", JSON.stringify(response.data));
            return response;
        } else {
            return response;
        }
    } catch (e) {
        if (e.response) {

        }
        return null;
    }
};

const logout = () => {
    localStorage.clear();
};
const forgotPassword = async (email) => {
    try {
        const response = await axios.post(`${apiUrl}${PORT}/auth-service/forget-password`, email);
        return response.data;
    } catch (e) {
        return e;
    }
};

const resetPassword = (data) => {
    return axios
        .post(`${apiUrl}${PORT}/auth-service/reset-password`, data,
            {
                headers: {
                    Authorization: 'Bearer ' + data.token
                }
            }

        )
        .then((response) => {
            return response.data;
        });
};



const verifyToken = (email, token) => {
    return axios
        .post(`${apiUrl}${PORT}/verify/token`, { email, token })
        .then((response) => {
            return response.data;
        });
};

/**
* @description registration in db.
* @param {*} data
* @param {*} callback
*/

export const registration = (data, callback, dispatch) => {
    try {
        //   dispatch(loadingAction(true));
        return axios
            .post(`${apiUrl}${PORT}/signup`, data)
            .then((response) => {
                //   dispatch(loadingAction(false));
                callback(response.data);
            })
            .catch((error) => {
                //   dispatch(loadingAction(false));
                callback(false);
            });
    } catch (err) {
    }
};

/**
 * @description contactUs in db.
 * @param {*} data
 * @param {*} callback
 */
export const contact_us = (data, callback, dispatch) => {
    try {
        //   dispatch(loadingAction(true));
        return axios
            .post(`${apiUrl}${PORT}/contact-us`, data)
            .then((response) => {
                //   dispatch(loadingAction(false));
                callback(response.data);
            })
            .catch((error) => {
                //   dispatch(loadingAction(false));
                callback(false);
            });
    } catch (err) {
    }
};

const AuthService = {
    login,
    logout,
    forgotPassword,
    verifyToken,
    resetPassword
};

export default AuthService;
